import routerMap from './routerMap';
import { useEffect } from 'react';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Modal } from 'antd';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { getConfigKeyApi, getPersonalInfo, getUserInfoApi, ssoLoginSuccess } from '../api/auth/auth';
import { getRoutersApi } from '../api/router/router';
import { getMenuVisible } from '../api/operations';
import { getSysVersionAppearanceApi } from '../api/userIntersection/userIntersection';
import LZLayout from '../pages/base/Layout';
import {
  setDataPermission,
  setDataPermissionInfo,
  setJumpLink,
  setMenu,
  setRfmName,
  setStyleStoreData,
  setUserDetail,
  setUserInfo,
  setUserToken,
  state,
} from '../store';
import busEvent from '../utils/bus';

const FrontendAuth = () => {
  const { pathname } = useLocation();
  const targetRouterConfig = routerMap.find(item => item.path === pathname);

  useEffect(() => {
    if ((!state.menu || state.menu.length === 0) && targetRouterConfig?.auth) {
      // getUserInfo();
      getUserInfoBySso();
    }
  }, [pathname]);

  useEffect(() => {
    busEvent.on('styleStoreData', getSysVersionAppearance);
  }, []);

  // 处理sso登录成功后返回到该系统后续操作
  const getUserInfoBySso = async () => {
    // 获取浏览器链接，并解析参数，查看是否有code参数
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const code = params.get('code');
    if (code) {
      const res = await ssoLoginSuccess({ code, state: '0' });
      if (res?.code === 200) {
        setUserToken(res.data.access_token, res.data.clientId);
        localStorage.setItem('accessType', res.data.accessType);
        getSysVersionAppearance();
      }
    } else {
      getSysVersionAppearance();
    }
    console.log('==链接参数==', code);
  };

  const getUserInfo = async (waterMarkContent: string, waterMarkStatus: string) => {
    const userInfo = await getUserInfoApi();
    if (userInfo) {
      const userDetail = await getPersonalInfo();
      if (userDetail) {
        setUserDetail(userDetail.data);
      }
      setDataPermission(userInfo.data?.dataPermission);
      setDataPermissionInfo(userInfo.data?.dataPermissionInfo);
      setUserInfo(userInfo.data);
      getRouters();
      getConfigKey();
      getConfigKeyRmf();
      getConfigKeyOlderMA();
      if (waterMarkStatus === '0') {
        busEvent.emit('userInfo', [userInfo.data.user.userName, waterMarkContent]);
      } else {
        busEvent.emit('userInfo', []);
      }
      // setMenu(menuList);
    }
  };

  // 获取header上面帮助中心icon的跳转链接
  const getConfigKey = async () => {
    const res = await getConfigKeyApi('lz.user.help');
    console.log(res);
    if (res?.code === 200) {
      setJumpLink(res.data);
    }
  };
  // 获取老ma短信标签的名
  const getConfigKeyOlderMA = async () => {
    const res = await getConfigKeyApi('lz.market.name');
    console.log(res);
    if (res?.code === 200) {
      localStorage.setItem('olderMaPlateformName', res.data.toString());
    }
  };

  // 更改menu左上的logo，需要更新getUserInfo
  const getSysVersionAppearance = async () => {
    const res = await getSysVersionAppearanceApi();
    if (res?.code === 200) {
      setStyleStoreData(res.data);
      getUserInfo(res.data.waterMarkContent, res.data.waterMarkStatus);
    }
  };

  const getConfigKeyRmf = async () => {
    const res = await getConfigKeyApi('lz.rmf.name ');
    console.log(res);
    if (res?.code === 200) {
      setRfmName(res.data.toString());
    }
  };

  const getRouters = async () => {
    const { data } = await getRoutersApi();
    console.log('🚀 ~ getRouters ~ data:', data);
    setMenu(data);
    // 运维中心：白名单用户动态 append 菜单（非白名单请求 403 时忽略）
    try {
      const opsRes: unknown = await getMenuVisible();
      const payload = opsRes as { code?: number; data?: boolean } | undefined;
      if (payload?.code === 200 && payload.data === true) {
        const next = [...data];
        if (!next.some((item: { label?: string }) => item?.label === '运维中心')) {
          next.push({
            label: '运维中心',
            key: '/operations/weeklyExchange',
            children: [{ label: 'EC兑换周更', key: '/operations/weeklyExchange' }],
          });
          setMenu(next as typeof data);
        }
      }
    } catch {
      // 非白名单/接口异常时静默忽略
    }
  };

  //如果路由配置项中直接跳转到对应页面
  if (targetRouterConfig && !targetRouterConfig?.layout) {
    return (
      <Routes>
        <Route
          path={pathname}
          element={targetRouterConfig?.component}
        />
      </Routes>
    );
  }

  if (targetRouterConfig) {
    if (pathname === '/') {
      console.log('🚀 ~ FrontendAuth ~ pathname:', pathname);
      console.log('==进入主页==', 1, targetRouterConfig);
      return (
        <Routes>
          {/* 导致header渲染了两次,于是注掉了 */}
          {/* <Route path="/" element={<LZLayout />}> */}
          <Route
            index
            element={targetRouterConfig.component}
          />
          {/* </Route> */}
        </Routes>
      );
    } else {
      console.log('🚀 ~ FrontendAuth ~ pathname:', pathname);
      console.log('==进入主页==', 2);
      return (
        <Routes>
          <Route
            path="/"
            element={<LZLayout />}>
            <Route
              path={pathname}
              element={targetRouterConfig.component}
            />
          </Route>
        </Routes>
      );
    }
  }

  // 如果路由不合法，重定向到 404 页面
  return (
    <Routes>
      <Route
        path="*"
        element={<div>404</div>}
      />
    </Routes>
  );
};
export default FrontendAuth;
